export const airDataNew = [
  {
    quarter: "Summer 2018",
    ozone: 1.7,
    co: 0.2,
  },
  {
    quarter: "Autumn 2018",
    ozone: 1.37,
    co: 0.27,
  },
  {
    quarter: "Winter 2018",
    ozone: 1.5,
    co: 0.23,
  },
  {
    quarter: "Spring 2018",
    ozone: 2.07,
    co: 0.17,
  },
  {
    quarter: "Summer 2019",
    ozone: 1.9,
    co: 0.17,
  },
  {
    quarter: "Autumn 2019",
    ozone: 1.07,
    co: 0.27,
  },
  {
    quarter: "Winter 2019",
    ozone: 1.53,
    co: 0.27,
  },
  {
    quarter: "Spring 2019",
    ozone: 2.53,
    co: 0.27,
  },
  {
    quarter: "Summer 2020",
    ozone: 2.07,
    co: 0.2,
  },
  {
    quarter: "Autumn 2020",
    ozone: 1.23,
    co: 0.3,
  },
  {
    quarter: "Winter 2020",
    ozone: 1.6,
    co: 0.27,
  },
  {
    quarter: "Spring 2020",
    ozone: 2.17,
    co: 0.2,
  },
  {
    quarter: "Summer 2021",
    ozone: 1.7,
    co: 0.2,
  },
  {
    quarter: "Autumn 2021",
    ozone: 1.1,
    co: 0.3,
  },
  {
    quarter: "Winter 2021",
    ozone: 1.57,
    co: 0.23,
  },
  {
    quarter: "Spring 2021",
    ozone: 1.93,
    co: 0.2,
  },
  {
    quarter: "Summer 2022",
    ozone: 1.43,
    co: 0.2,
  },
  {
    quarter: "Autumn 2022",
    ozone: 1,
    co: 0.27,
  },
  {
    quarter: "Winter 2022",
    ozone: 1.53,
    co: 0.23,
  },
  {
    quarter: "Spring 2022",
    ozone: 1.8,
    co: 0.2,
  },
  {
    quarter: "Summer 2023",
    ozone: 1.67,
    co: 0.17,
  },
  {
    quarter: "Autumn 2023",
    ozone: 1.03,
    co: 0.13,
  },
]
